export default __webpack_public_path__ + "static/media/footer_bg_top_Asset.41d2ba22.png";